export default "__VITE_ASSET__CHryp0iQ__"